export default __webpack_public_path__ + "static/media/content-section_reversed.881e8c07.svg";